import { ContactCreate } from './ContactCreate'
import { ContactEdit } from './ContactEdit'
import { ContactList } from './ContactList'
import { ContactShow } from './ContactShow'

export { ContactCreate, ContactEdit, ContactList, ContactShow }
